var _path, _rect, _rect2, _polygon, _polygon2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7 3.6c2.6 0 4.8 2.2 4.8 4.8V63c0 2.6-2.2 4.8-4.8 4.8H8.3c-2.6 0-4.8-2.2-4.8-4.8V8.4c0-2.6 2.2-4.8 4.8-4.8H81.7M81.7 0.1H8.3C3.7 0.1 0 3.8 0 8.4V63c0 4.6 3.7 8.3 8.3 8.3h73.4c4.6 0 8.3-3.7 8.3-8.3V8.4C90 3.8 86.3 0.1 81.7 0.1L81.7 0.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.9,
    y: 73.6,
    width: 20.2,
    height: 9.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 86.4,
    width: 44.7,
    height: 3.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.6 43.5 8.2 36.1 15.6 28.7 17.2 30.3 11.4 36.1 17.2 41.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.4 43.5 81.8 36.1 74.4 28.7 72.8 30.3 78.6 36.1 72.8 41.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 14.3c-11.1 0-20.1 9-20.1 20.1v23.5l11.1-5.6 9.1 5.6 9.1-5.6 11.1 5.6V34.4C65.1 23.3 56.1 14.3 45 14.3zM36.2 34.8c-2.1 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9C40.1 33 38.4 34.8 36.2 34.8zM53.8 34.8c-2.1 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9C57.6 33 55.9 34.8 53.8 34.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/recipe.50c6717be627d43bcd55c129609ecbca.svg";
export { ForwardRef as ReactComponent };